import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import StickyCta from "@/pages/home/components/StickyCta";
import Contact from "@/pages/home/components/Contact";
import ServiceHero from "@/pages/gomi-yashiki/components/ServiceHero";
import Reasons from "@/pages/gomi-yashiki/components/Reasons";
import Items from "@/pages/gomi-yashiki/components/Items";
import Pricing from "@/pages/gomi-yashiki/components/Pricing";
import Flow from "@/pages/gomi-yashiki/components/Flow";
import ServiceAreas from "@/components/feature/ServiceAreas";
import Faq from "@/pages/gomi-yashiki/components/Faq";
import ServiceTrust from "@/components/feature/ServiceTrust";
import RelatedServices from "@/components/feature/RelatedServices";

const gomiYashikiNavItems = [
  { href: "#reasons", label: "選ばれる理由" },
  { href: "#items", label: "作業内容" },
  { href: "#pricing", label: "料金目安" },
  { href: "#flow", label: "作業の流れ" },
  { href: "#areas", label: "対応エリア" },
  { href: "#faq", label: "よくある質問" },
  { href: "#trust", label: "運営会社" },
  { href: "#related", label: "関連サービス" },
];

const relatedServices = [
  {
    title: "不用品回収",
    href: "/fuyouhin-kaisyu",
    description:
      "家具・家電・大型ゴミの回収はこちら。清掃後に残った不用品の回収もお任せください。",
    icon: "ri-truck-line",
  },
  {
    title: "遺品整理",
    href: "/ihin-seiri",
    description:
      "ご遺族様の遺品整理はこちら。貴重品の仕分けから供養・形見分けまで一貫サポートします。",
    icon: "ri-hand-heart-line",
  },
];

export default function GomiYashikiPage() {
  return (
    <div className="w-full min-w-[320px] bg-background-50 text-foreground-950">
      <Header linkPrefix="" navItems={gomiYashikiNavItems} />
      <main>
        <ServiceHero />
        <Reasons />
        <Items />
        <Pricing />
        <Flow />
        <ServiceAreas description="京都市内を中心に、京都府内の幅広いエリアへゴミ屋敷清掃に伺います。近隣に配慮した作業で対応します。" />
        <Faq />
        <ServiceTrust />
        <RelatedServices items={relatedServices} />
        <Contact />
      </main>
      <Footer linkPrefix="/" />
      <StickyCta />
    </div>
  );
}